import { render, staticRenderFns } from "./PerformancePanel.vue?vue&type=template&id=01b6ea5e&"
import script from "./PerformancePanel.vue?vue&type=script&lang=js&"
export * from "./PerformancePanel.vue?vue&type=script&lang=js&"
import style0 from "./PerformancePanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports